export type NavLeaf = {
  label: string;
  href: string;
  external?: true;
};

export type NavGroup = {
  label: string;
  href?: string;
  children: readonly NavItem[];
};

export type NavItem = NavLeaf | NavGroup;

export function isNavGroup(item: NavItem): item is NavGroup {
  return "children" in item;
}

export function buildNavigation(currentYear: number): readonly NavItem[] {
  return [
    {
      label: "Guests",
      children: [
        { label: `${currentYear} Guests`, href: `/guests/${currentYear}` },
        { label: "Previous Guests", href: "/guests/previous" },
        { label: "Autographs", href: "/guests/autographs" },
      ],
    },
    {
      label: "Programming",
      children: [
        {
          label: "Cosplay",
          children: [
            { label: "Masquerade Contest", href: "/programming/cosplay/masquerade" },
            { label: "Cosplay Repair", href: "/programming/cosplay/repair" },
          ],
        },
        {
          label: "Gaming",
          children: [
            { label: "Video Gaming", href: "/programming/gaming/video" },
            { label: "Collectible Card Gaming", href: "/programming/gaming/ccg" },
            { label: "Tabletop Gaming", href: "/programming/gaming/tabletop" },
            { label: "Roleplay Gaming", href: "/programming/gaming/roleplay" },
            { label: "Arcade Gaming", href: "/programming/gaming/arcade" },
          ],
        },
        {
          label: "Activity Rooms",
          children: [
            // {
            //   label: "Convention Foam Fighting",
            //   href: "/programming/activity-rooms/convention-foam-fighting",
            // },
            { label: "The Night Market", href: "/programming/activity-rooms/night-market" },
            // { label: "Adventure Room", href: "/programming/activity-rooms/escape-rooms" },
            { label: "Movement Room", href: "/programming/activity-rooms/movement" },
            // { label: "Otaku Manga Lounge", href: "/programming/activity-rooms/otaku-manga-lounge" },
          ],
        },
        {
          label: "Dancing",
          children: [
            // { label: "Electronic Dance Matsuri", href: "/programming/dancing/electronic-dance-matsuri" },
            { label: "K-Pop/J-Pop Dance Gala", href: "/programming/dancing/kpop-jpop-dance-gala" },
            { label: "The Formal Ball", href: "/programming/dancing/formal-ball" },
          ],
        },
        // { label: "Matsuri Ink", href: "/programming/matsuri-ink" },
        { label: "Badge Ribbons", href: "/programming/badge-ribbons" },
        // { label: "V.E.S. AMV Contest", href: "/programming/ves-amv-contest" },
        // { label: "Matsuri Karaoke", href: "/programming/matsuri-karaoke" },
        { label: "Photoshoots", href: "/programming/photoshoots" },
        // { label: "Storytellers Forge", href: "/programming/storytellers-forge" },
      ],
    },
    {
      label: "Registration",
      children: [
        { label: "Attend", href: "/registration/attend" },
        { label: "Be a Panelist", href: "/registration/panelist" },
        { label: "Volunteer", href: "/registration/volunteer" },
      ],
    },
    {
      label: "Plan Your Visit",
      children: [
        { label: "Getting Here", href: "/plan/getting-here" },
        { label: "Hotels", href: "/plan/hotels" },
        { label: "Artist Alley", href: "/plan/artist-alley" },
        { label: "Vendors", href: "/plan/vendors" },
        { label: "Convention Schedule", href: "/plan/schedule" },
        // { label: "My Ribbons", href: "/plan/my-ribbons" },
        { label: "Convention Maps", href: "/plan/maps" },
      ],
    },
    {
      label: "About",
      children: [
        { label: "Contact Us", href: "/about/contact" },
        { label: "Charity", href: "/about/charity" },
        { label: "Policies & Safety", href: "/about/policies" },
        { label: "Advertising & Con Swaps", href: "/about/advertising" },
      ],
    },
    { label: "Merch", href: "https://matsuricon.square.site/", external: true },
  ] as const;
}
